import React from "react";
import { X } from "lucide-react";

type ModalProps = {
  open?: boolean;
  onClose?: () => void;
  header?: React.ReactNode;
  children?: React.ReactNode;
  size?: "small" | "medium" | "large";
};

export default function Modal({
  open = true,
  onClose,
  header,
  children,
  size = "medium",
}: ModalProps) {
  if (!open) return null;

  return (
    <div className="Modal">
      <div className="Modal__overlay">
        <div
          className={`Modal__box Modal__box__${size}`}
          onClick={(e) => e.stopPropagation()}
        >
          {onClose && (
            <button
              className="Modal__close-button"
              onClick={onClose}
              aria-label="Chiudi"
            >
              <X size={20} />
            </button>
          )}
          {header && <div className="Modal__header">{header}</div>}
          <div className="Modal__body">{children}</div>
        </div>
      </div>
    </div>
  );
}
